module.exports = __webpack_public_path__ + "static/media/sidebar-customer-management.ad27a572.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-customer-management.svg
// module id = 797
// module chunks = 0